enum IWaveConnectBroadcastChannelMessageType {
  CONNECTED = 'connected',
  CLOSE_AUTH_WINDOW = 'close-auth-window',
}

export default IWaveConnectBroadcastChannelMessageType;
